import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ConfirmDialogData {
    title: string;
    content: string;
    confirmText: string;
    cancelText: string;
}

@Component({
    selector: 'syn-confirm-dialog',
    templateUrl: 'confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
    @Input() title: string;
    @Input() content: string;
    @Input() confirmText: string;
    @Input() cancelText: string;

    constructor(
        private matDialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    ) {
    }

    public confirm(): void {
        this.matDialogRef.close(true);
    }

    public cancel(): void {
        this.matDialogRef.close(false);
    }
}
